<template>
<v-container>
  <v-chip>
    2.1 Career detail
  </v-chip>
  <h1>Career</h1>
    <v-container>
      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn icon to="/explore-careers">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-card-text>
        {{ getCareer(thisCareer).name}}<br/>
        {{ getCareer(thisCareer).title}}<br/>
        {{ getCareer(thisCareer).longDescription}}
      </v-card-text>
    </v-card>
    <v-layout row>
      <v-flex xs4 v-for="(image, index) in getCareer(thisCareer).gallery" :key="index">
        <v-img :src="image" class="m-career--gallery-item"/>
      </v-flex>
    </v-layout>
    </v-container>
</v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      thisCareer: this.$route.params.id,
    };
  },
  computed: {
    careers() {
      return this.$store.state.careers;
    },
    ...mapGetters(['getCareer']),
  },
};
</script>

<style lang='scss' scoped>
  .m-career--gallery-item {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Careers/Career.vue